import { render, staticRenderFns } from "./busquedaElemento.vue?vue&type=template&id=2172fee4"
import script from "./busquedaElemento.vue?vue&type=script&lang=js"
export * from "./busquedaElemento.vue?vue&type=script&lang=js"
import style0 from "./busquedaElemento.vue?vue&type=style&index=0&id=2172fee4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports